/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum constraint_item_types {
  NINTH_AGE_ARMY = 'NinthAge::Army',
  NINTH_AGE_UNIT = 'NinthAge::Unit',
  NINTH_AGE_UNIT_OPTION = 'NinthAge::UnitOption',
  NINTH_AGE_TROOP = 'NinthAge::Troop',
  NINTH_AGE_ARMY_ORGANISATION = 'NinthAge::ArmyOrganisation',
  NINTH_AGE_CONSTRAINT = 'NinthAge::Constraint',
}
